import * as types from "../constants/actionConstants";


const initialState = [];


function questionnaireTemplateListReducer(state = initialState, action) {
    switch (action.type) {
        case types.QUESTIONNAIRE_TEMPLATE_LIST_GET_SUCCESS:
        case types.QUESTIONNAIRE_TEMPLATE_LIST_CURRENT_GET_SUCCESS:
            return action.list;

        default:
            return state;
    }
}

export default questionnaireTemplateListReducer;